import { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { LayoutProvider } from "../_metronic/layout/core";
import { MasterInit } from "../_metronic/layout/MasterInit";
import { ThemeModeProvider } from "../_metronic/partials/layout/theme-mode/ThemeModeProvider";
import CompanyProvider from "app/modules/system/whiteLabelling/CompanyProvider";
import AuthInit from "./modules/auth/redux/AuthInit";
import { ServerErrorAlert } from "./system/errors/ServerErrorAlert";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "setup/redux/RootReducer";
import LayoutSplashScreen from "_metronic/layout/core/LayoutSplashScreen";
import CookieBanner from "./system/cookies/CookieBanner";
import ErrorHandler from "./modules/errors/ErrorHandler";
import { postAuthTokenToServiceWorker } from "services/serviceWorkerAuthToken";

const App = () => {
  const token = useSelector<RootState>(({ auth }) => auth.token, shallowEqual) as string | undefined;

  useEffect(() => {
    const registerServiceWorker = async () => {
      if ("serviceWorker" in navigator) {
        try {
          await navigator.serviceWorker.register("/sw.js", {
            scope: "/",
          });
          await navigator.serviceWorker.ready;

          postAuthTokenToServiceWorker(token);
        } catch (error) {
          console.error(`Service worker failed with ${error}`);
        }
      }
    };

    registerServiceWorker();
  }, [token]);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <LayoutProvider>
        <CompanyProvider>
          <ThemeModeProvider>
            <AuthInit>
              <CookieBanner />
              <Outlet />
              <ErrorHandler />
              <ServerErrorAlert />
              <MasterInit />
            </AuthInit>
          </ThemeModeProvider>
        </CompanyProvider>
      </LayoutProvider>
    </Suspense>
  );
};

export { App };
